import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GoogleMap } from 'react-google-maps';
import * as actions from 'src/redux/searchActions';
import { default as ScriptjsLoader } from "react-google-maps/lib/async/ScriptjsLoader";
import config from '../../../config';
import markerIcon from 'src/imgs/map-marker.png';
import noop from 'lodash/noop';
import styles from '../SearchResults.scss';
import mobileStyles from '../SearchResultsMobile.scss';
import { isDesktop } from 'src/logic/utils';
import cx from 'classnames';
import SearchMapMarker from './SearchMapMarker';
import MapLoadingElement from 'src/components/Map/MapLoadingElement';
import _ from 'lodash';

class SearchMap extends Component {
  state = {
    expandedMarkerPartnerLocationId: undefined,
  };

  expandMarker = (partnerLocationId) => {
    this.setState({
      expandedMarkerPartnerLocationId: partnerLocationId,
    });
  };

  collapseMarker = () => this.setState({
    expandedMarkerPartnerLocationId: null,
  });

  render() {
    const {
      partnerLocations = [],
      searchByPartnerId,
    } = this.props;

    const rightColClassName = cx({
      [styles.right_col]: isDesktop(),
    });
    return (
      <div className={rightColClassName}>
        <ScriptjsLoader
          hostname={config.gMapScriptPath.host}
          pathname={config.gMapScriptPath.path}
          query={{key: config.gMapKey}}
          loadingElement={<MapLoadingElement />}
          containerElement={<div className={styles.mapContainer} />}
          googleMapElement={
            <GoogleMap
              defaultCenter={config.defaultMapCenter}//{config.defaultMapCenter} //TODO: need city center
              defaultZoom={config.defaultMapZoom}
              onClick={this.collapseMarker}
              >
              {_(partnerLocations).map((location, index) => (
                <SearchMapMarker
                  position={{lat: location.latitude, lng : location.longitude}}
                  key={location.partnerLocationId}
                  expandedId={this.state.expandedMarkerPartnerLocationId}
                  id={location.partnerLocationId}
                  icon="none"
                  isChosenPVZ={location.chosenPVZ}
                  searchByPartnerId={searchByPartnerId}
                  expandMarker={this.expandMarker}
                  collapseMarker={this.collapseMarker}
                  searchQuery={this.props.searchQuery}
                  choosePartner={this.props.choosePartner}
                  submitSearch={this.props.submitSearch}
                  {...location}
                />
              )).value()}
            </GoogleMap>
          }
        />
      </div>
    );
  }
}



export default connect(
  (state) => ({
    ...state.searchReducer,
    chosenPartner: state.toCartPopupReducer.chosenPartner
  }),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(SearchMap);



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/SearchMap.jsx
 **/